<ng-container
  *ngFor="let widget of input.widgets; trackBy: trackByWidgetId"
  [dynamicWidget]="widget"
  [context]="context"
></ng-container>
